/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NTPServerUpdate
 */
export interface NTPServerUpdate {
    /**
     * 
     * @type {string}
     * @memberof NTPServerUpdate
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof NTPServerUpdate
     */
    options?: string;
}

export function NTPServerUpdateFromJSON(json: any): NTPServerUpdate {
    return NTPServerUpdateFromJSONTyped(json, false);
}

export function NTPServerUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): NTPServerUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'options': !exists(json, 'options') ? undefined : json['options'],
    };
}

export function NTPServerUpdateToJSON(value?: NTPServerUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'options': value.options,
    };
}


